import axios from 'axios'
import { DEVOLVER_FECHAMENTO_CAIXA } from '../../types'
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil'
import { URL } from '../../../util/ambienteActions';

export default function devolverFechamentoCaixa (fechamentoCaixaId, observacao, codigoEmpresa) {
  const url = `${URL}/fechamento-caixa-usuario/${fechamentoCaixaId}/empresa/${codigoEmpresa}/devolver`;
  return dispatch => axios.post(url, { observacao }, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: DEVOLVER_FECHAMENTO_CAIXA,
        payload: response
      })
  );
}
